<template>
  <div class="w1200 newsBox">
    <!--<div class="top">-->
    <!--<div class="dataBaseTopBox">-->
    <!--<div class="navs">-->
    <!--<div class="w1200s">-->
    <!--<ul class="head-ul">-->
    <!--<li class="'noactive">-->
    <!--<a target="_blank" href="http://www.pengzushijia.com/" class="navli">-->
    <!--平台导航-->
    <!--</a>-->
    <!--</li>-->
    <!--<li :class="currentIndex===0?'avtive':'noactive'" @click="gonav(0)">-->
    <!--<router-link tag="a" :to="{name:'ho',query:{index:0}}" class="navli">-->
    <!--首页-->
    <!--</router-link>-->
    <!--</li>-->
    <!--<li :class="currentIndex===1?'avtive':'noactive'" @click="gonav(1)">-->
    <!--<router-link tag="a" :to="{name:'ne',params:{templateId:'NEWS'},query:{index:1}}" class="navli">-->
    <!--资讯-->
    <!--</router-link>-->
    <!--</li>-->
    <!--<li :class="currentIndex===2?'avtive':'noactive'" @click="gonav(2)">-->
    <!--<router-link tag="a" :to="{name:'at',params:{templateId:'PHOTO'},query:{index:2}}" class="navli">-->
    <!--图集-->
    <!--</router-link>-->
    <!--</li>-->
    <!--<li :class="currentIndex===3?'avtive':'noactive'" @click="gonav(3)">-->
    <!--<router-link tag="a" :to="{name:'vd',params:{templateId:'VIDEO'},query:{index:3}}" class="navli">-->
    <!--视频-->
    <!--</router-link>-->
    <!--</li>-->
    <!--<li :class="currentIndex===4?'avtive':'noactive'" @click="gonav(4)">-->
    <!--<router-link tag="a" :to="{name:'li',params:{templateId:'DOC'},query:{index:4}}" class="navli">-->
    <!--文库-->
    <!--</router-link>-->
    <!--</li>-->
    <!--<li :class="currentIndex===5?'avtive':'noactive'" @click="gonav(5)">-->
    <!--<router-link tag="a" :to="{name:'al',query:{index:5}}" class="navli">-->
    <!--专辑-->
    <!--</router-link>-->
    <!--</li>-->
    <!--<li :class="currentIndex===6?'avtive':'noactive'" @click="gonav(6)">-->
    <!--<router-link tag="a" :to="{name:'sp',query:{index:6}}" class="navli">-->
    <!--专题-->
    <!--</router-link>-->
    <!--</li>-->
    <!--<li :class="currentIndex===7?'avtive':'noactive'" @click="gonav(7)">-->
    <!--<router-link tag="a" :to="{name:'datab'}" class="navli">-->
    <!--总数据库-->
    <!--</router-link>-->
    <!--</li>-->
    <!--&lt;!&ndash;              <li :class="currentIndex===8?'avtive':'noactive'" @click="gonav(8)">&ndash;&gt;-->
    <!--&lt;!&ndash;                <router-link tag="a" :to="{name:'roots'}" class="navli">&ndash;&gt;-->
    <!--&lt;!&ndash;                  根籍搜索&ndash;&gt;-->
    <!--&lt;!&ndash;                </router-link>&ndash;&gt;-->
    <!--&lt;!&ndash;              </li>&ndash;&gt;-->
    <!--<li class="'noactive">-->
    <!--<a target="_blank" href="http://maker.pengzushijia.com/" class="navli">-->
    <!--编撰平台-->
    <!--</a>-->
    <!--</li>-->
    <!--</ul>-->
    <!--<div class="right_box">-->
    <!--<div v-show="!islogin" class="login_register">-->
    <!--<a href="/login">登录</a>-->
    <!--<a href="/register">注册</a>-->
    <!--</div>-->
    <!--<div v-show="islogin" class="userBox">-->
    <!--<div class="imgBox">-->
    <!--<img v-if="userData.USER_PHOTO" :src="userData.USER_PHOTO" alt="">-->
    <!--<img v-else :src="noIMG" alt="">-->
    <!--</div>-->
    <!--<div class="usercontent" @click="goUserMsg(0)">-->
    <!--<el-tooltip class="item" effect="dark" :content="userData.USER_MOBILE" placement="top-start">-->
    <!--<span v-if="userData.USER_NAME">{{ userData.USER_NAME }}</span>-->
    <!--<span v-else>{{ userData.USER_MOBILE }}</span>-->
    <!--</el-tooltip>-->
    <!--</div>-->
    <!--<ul class="list">-->
    <!--<li v-for="(item,index) in arrs" :key="index" @click="goUserMsg(index)">-->
    <!--{{ item.name }}-->
    <!--</li>-->
    <!--</ul>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="w1200">-->
    <!--<div class="logoBox">-->
    <!--<img :src="logo" alt="">-->
    <!--</div>-->
    <!--<div class="searchbox">-->
    <!--<input v-model="keys" type="text" class="keys_input" placeholder="输入关键字搜索"><div class="btn" @click="goSearch">-->
    <!--一键搜索-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->

    <div class="bannerbox" :style="'background-image:url('+banner_big+')'">
    <!--<p class="numberCount">-->
    <!--<countTo class="newCount" :start-val="countNUmber.startVal" :end-val="countNUmber.endVal" :duration="1000" />-->
    <!--</p>-->
    </div>
    <div class="content w1200">
      <!--<div class="topshow">-->
      <!--<a class="lis" target="_blank" href="http://www.pengzushijia.com" :style="topbgc1">-->
      <!--<p>《彭祖世家总谱·事典》</p>-->
      <!--<p>总谱官网及门户网站</p>-->
      <!--<span>点击进入</span>-->
      <!--</a>-->
      <!--<a class="lis" target="_blank" href="http://maker.pengzushijia.com" :style="topbgc2">-->
      <!--<p>《彭祖世家总谱·事典》</p>-->
      <!--<p>互联网编撰平台</p>-->
      <!--<span>点击进入</span>-->
      <!--</a>-->
      <!--<a class="lis" target="_blank" href="http://admin.pengzushijia.com" :style="topbgc1">-->
      <!--<p>《彭祖世家总谱·事典》</p>-->
      <!--<p>总数据库综合管理平台</p>-->
      <!--<span>点击进入</span>-->
      <!--</a>-->
      <!--</div>-->
      <!--谱书-->
      <!--<div class="numberShow">-->
      <!--<div class="topbgc" />-->
      <!--<div class="numberShow_lis">-->
      <!--<div class="numberShow_lis_top">-->
      <!--<div class="numberShow_lis_top_fb">-->
      <!--<div class="top_icon">-->
      <!--<svg-icon icon-class="puxiicon" />-->
      <!--</div>-->
      <!--<p>谱系</p>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="numberShow_lis_center">-->
      <!--152-->
      <!--</div>-->
      <!--<div class="numberShow_lis_add">-->
      <!--<span>今日新增: </span><span class="num">2</span>-->
      <!--</div>-->
      <!--<div class="numberShow_lis_btn">-->
      <!--查看-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="numberShow_lis">-->
      <!--<div class="numberShow_lis_top">-->
      <!--<div class="numberShow_lis_top_fb">-->
      <!--<div class="top_icon">-->
      <!--<svg-icon icon-class="puxiicon" />-->
      <!--</div>-->
      <!--<p>谱系</p>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="numberShow_lis_center">-->
      <!--152-->
      <!--</div>-->
      <!--<div class="numberShow_lis_add">-->
      <!--<span>今日新增: </span><span class="num">2</span>-->
      <!--</div>-->
      <!--<div class="numberShow_lis_btn">-->
      <!--查看-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="numberShow_lis">-->
      <!--<div class="numberShow_lis_top">-->
      <!--<div class="numberShow_lis_top_fb">-->
      <!--<div class="top_icon">-->
      <!--<svg-icon icon-class="puxiicon" />-->
      <!--</div>-->
      <!--<p>谱系</p>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="numberShow_lis_center">-->
      <!--152-->
      <!--</div>-->
      <!--<div class="numberShow_lis_add">-->
      <!--<span>今日新增: </span><span class="num">2</span>-->
      <!--</div>-->
      <!--<div class="numberShow_lis_btn">-->
      <!--查看-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="numberShow_lis">-->
      <!--<div class="numberShow_lis_top">-->
      <!--<div class="numberShow_lis_top_fb">-->
      <!--<div class="top_icon">-->
      <!--<svg-icon icon-class="puxiicon" />-->
      <!--</div>-->
      <!--<p>谱系</p>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="numberShow_lis_center">-->
      <!--152-->
      <!--</div>-->
      <!--<div class="numberShow_lis_add">-->
      <!--<span>今日新增: </span><span class="num">2</span>-->
      <!--</div>-->
      <!--<div class="numberShow_lis_btn">-->
      <!--查看-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="hotShow">-->
      <!--<div class="hotShow_like">-->
      <!--<div class="toptitle">-->
      <!--<p class="toptitle_p1">-->
      <!--最爱修谱-->
      <!--</p>-->
      <!--<p class="toptitle_p2">-->
      <!--活跃用户，录入数据最多的地区-->
      <!--</p>-->
      <!--</div>-->
      <!--<div class="hotShow_like_center">-->
      <!--江西省-->
      <!--</div>-->
      <!--<div class="hotShow_like_user">-->
      <!--<div class="imgBox">-->
      <!--<img src="" alt="">-->
      <!--</div>-->
      <!--<span>996人</span>-->
      <!--</div>-->
      <!--<div class="hotShow_like_num">-->
      <!--录入人物: 5254-->
      <!--</div>-->
      <!--<div>-->
      <!--<contentControl :arry-length="arry" @indexchange="indexchange1" />-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="hotShow_hot">-->
      <!--<div class="toptitle">-->
      <!--<p class="toptitle_p1">-->
      <!--最热谱书-->
      <!--</p>-->
      <!--<p class="toptitle_p2">-->
      <!--精挑细选，最受好评谱书-->
      <!--</p>-->
      <!--</div>-->
      <!--<div class="hotShow_hot_img">-->
      <!--<img src="@/static/peng_banner3.png" alt="">-->
      <!--</div>-->
      <!--<div class="hotShow_like_num">-->
      <!--289人次，在线阅读-->
      <!--</div>-->
      <!--<div>-->
      <!--<contentControl :arry-length="arry" @indexchange="indexchange2" />-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="hotShow_user">-->
      <!--<div class="toptitle">-->
      <!--<p class="toptitle_p1">-->
      <!--修谱大神-->
      <!--</p>-->
      <!--<p class="toptitle_p2">-->
      <!--热衷修谱，最核心的贡献者-->
      <!--</p>-->
      <!--</div>-->
      <!--<div class="hotShow_user_img">-->
      <!--<img src="@/static/peng_banner3.png" alt="">-->
      <!--<p class="username">-->
      <!--程小雨-->
      <!--</p>-->
      <!--</div>-->
      <!--<div class="hotShow_like_num">-->
      <!--录入人物: 5254-->
      <!--</div>-->
      <!--<div>-->
      <!--<contentControl :arry-length="arry" @indexchange="indexchange3" />-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="hotShow_newmsg">-->
      <!--<div class="toptitle">-->
      <!--<p class="toptitle_p1">-->
      <!--用户动态-->
      <!--</p>-->
      <!--<p class="toptitle_p2">-->
      <!--他们正在编修家谱-->
      <!--</p>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--谱书-->
      <!--<div class="firstcolumn_tip">-->
      <!--&lt;!&ndash;<img :src="pushu" alt="">&ndash;&gt;-->
      <!--推荐谱书-->
      <!--</div>-->
      <pushu />
      <!--谱系-->
      <!--<div class="firstcolumn_tip">-->
      <!--&lt;!&ndash;<img :src="pushu" alt="">&ndash;&gt;-->
      <!--推荐谱系-->
      <!--</div>-->
      <puxi />
      <!--<div class="firstcolumn_tip">-->
      <!--&lt;!&ndash;<img :src="pushu" alt="">&ndash;&gt;-->
      <!--推荐谱文-->
      <!--</div>-->
      <!--谱文-->
      <puwen />
      <!--<div class="firstcolumn_tip">-->
      <!--&lt;!&ndash;<img :src="pushu" alt="">&ndash;&gt;-->
      <!--推荐人物-->
      <!--</div>-->
      <!--谱人物-->
      <purenwu />
    </div>
    <!--<div class="foot_banners">-->
    <!--<img :src="banner_foot" alt="">-->
    <!--<p class="p1">-->
    <!--彭家人自己的修谱平台-->
    <!--</p>-->
    <!--<p class="p2">-->
    <!--《彭祖世家总谱·事典》编纂平台-->
    <!--</p>-->
    <!--<p class="p3">-->
    <!--<a href="http://maker.pengzushijia.com" target="_blank">进入平台，创建家谱</a>-->
    <!--</p>-->
    <!--</div>-->
  </div>
</template>
<script>
import pushu from '@/views/firstlist/firstpushu/index.vue'
import puxi from '@/views/firstlist/firstpuxi/index.vue'
import puwen from '@/views/firstlist/firstpuwen/index.vue'
import purenwu from '@/views/firstlist/firstpurenwu/index.vue'
import countTo from 'vue-count-to'
import contentControl from '@/views/components/contentControl/contentControl.vue'
export default {
  head() {
    // var listObj = this.$store.state.hotList_home
    var metaStr = ''
    // listObj.forEach(a => {
    //   metaStr += a.CONTENT_TITLE + ' | '
    // })
    return {
      title: '国谱馆-中国谱_大中国谱_中国族谱收录_中国名人_中国谱网-彭祖世家网',
      mateDesc: '通过中国世代家谱,中国家谱总录,中国族谱家谱大全,中国家谱知识,国家家谱了解中国家谱历史,中国族谱历史发展渊源,发扬国家传统,国家有史,家谱有谱',
      keys: '家谱,百姓,门第,家族,玉牒,姓氏文化,名族融合,官修,族规'
    }
  },
  components: { pushu, puxi, puwen, purenwu, countTo, contentControl },
  data() {
    return {
      arry: ['1', '2', '3', '4', '5'],
      countNUmber: {
        startVal: 0,
        endVal: 12493485
      },
      noIMG: require('@/static/home_noimg.png'),
      keys: '',
      logo: require('@/static/search_logo_peng.png'),
      currentIndex: 0,
      islogin: false,
      username: '',
      userData: {},
      arrs: [{ 'name': '账号设置' }, { 'name': '我的收藏' }, { 'name': '我的评论' }, { 'name': '我的消息' }, { 'name': '退出登录' }],
      banner_big: require('@/static/guoouBanner.jpg'),
      banner_foot: require('@/static/banner_foot.png'),
      topbgc1: {
        backgroundImage: 'url(' + require('@/static/topbgc1.png') + ')'
      },
      topbgc2: {
        backgroundImage: 'url(' + require('@/static/topbgc2.png') + ')'
      },
      topbgc3: {
        backgroundImage: 'url(' + require('@/static/topbgc3.png') + ')'
      }
    }
  },
  created() {

  },
  mounted() {
    // if (this.getLoca('username')) {
    //   this.username = this.getLoca('username').substring(7)
    // }
  },
  methods: {
    gonav: function(index) {
      this.currentIndex = index
    },
    goSearch: function() {
      if (this.keys) {
        this.$router.push({ path: '/allDataSearch', query: { searchName: this.keys }})
      } else {
        this.$message({
          message: '请输入关键字',
          type: 'warning',
          duration: 1500
        })
      }
    },
    indexchange1: function(index) {

    },
    indexchange2: function(index) {

    },
    indexchange3: function(index) {

    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss">
  .newCount{
    font-size: 56px;
  }
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
  .numberShow{
    width: 1200px;
    height: 344px;
    background-color: #ffffff;
    border-radius:0 0 8px 8px;
    border-bottom: 1px solid #F5F5F5;
    .topbgc{
      border-radius: 8px 8px 0 0;
      background-color: #F5F5F5;
      height: 78px;
    }
    .numberShow_lis{
      /*background-color: red;*/
      width: 300px;
      height: 267px;
      display: inline-block;
      position: relative;
      text-align: center;
      vertical-align: top;
      .numberShow_lis_top {
        width: 120px;
        height: 120px;
        display: inline-block;
        position: absolute;
        top: -60px;
        left: 90px;
        background-color: #F5F5F5;
        border-radius: 50%;
        line-height: 120px;
        text-align: center;
        .numberShow_lis_top_fb {
          width: 118px;
          height: 118px;
          display: inline-block;
          background-color: #ffffff;
          border-radius: 50%;
          .top_icon {
            text-align: center;
            margin-top: 30px;
            line-height: 45px;
            height: 45px;
            svg {
              font-size: 45px;
              color: #CCCCCC;
            }
          }
          p {
            font-size: 14px;
            text-align: center;
            color: #333333;
            margin-top: 10px;
            line-height: 20px;
            height: 20px;
          }
        }
      }
      .numberShow_lis_center{
        height: 95px;
        line-height: 95px;
        font-size: 30px;
        color: #333333;
        font-weight: 600;
        text-align: center;
        margin-top: 60px;
      }
      .numberShow_lis_add{
        height: 20px;
        line-height: 20px;
        text-align: center;
        span{
          font-size: 14px;
          color: #333333;
        }
        .num{
          margin-left: 10px;
        }
      }
      .numberShow_lis_btn{
        width: 135px;
        height: 35px;
        line-height: 35px;
        border: 1px solid #E4E4E4;
        border-radius:5px;
        text-align: center;
        color: #999999;
        cursor: pointer;
        display: inline-block;
        margin-top: 30px;
        font-size: 14px;
        &:hover{
          background-color: #FF9933;
          color: #ffffff;
          border-color:#FF9933;
        }
      }
    }
  }
  .hotShow{
    background-color: #F2F2F2;
    overflow: hidden;
    padding: 20px 0;
    .hotShow_like{
      width: 280px;
      height: 480px;
      background-color: #fff;
      text-align: center;
      display: inline-block;
      vertical-align: top;
      .toptitle{
        height: 125px;
        background-color: #60C8E6;
        .toptitle_p1{
          font-size: 32px;
          color: #ffffff;
          text-align: center;
          padding-top: 25px;
        }
        .toptitle_p2{
          font-size: 14px;
          color: #ffffff;
          text-align: center;
          margin-top: 10px;
        }
      }
      .hotShow_like_center{
        height: 190px;
        line-height: 190px;
        font-weight: 600;
        font-size: 33px;
        color: #333333;
        text-align: center;
      }
      .hotShow_like_user{
        height: 40px;
        line-height: 40px;
        padding-left: 35px;
        margin-bottom: 50px;
        .imgBox{
          width: 40px;
          height: 40px;
          display: inline-block;
          img{
            width: 40px;
            height: 40px;
          }
        }
        span{
          font-size: 12px;
          color: #CCCCCC;
          margin-left: 20px;
        }
      }
      .hotShow_like_num{
        display: inline-block;
        margin-bottom: 8px;
        width: 220px;
        height: 35px;
        text-align: center;
        line-height: 35px;
        border: 1px solid #F2F2F2;
        font-size: 14px;
        color: #333333;
      }
    }
    .hotShow_hot{
      width: 280px;
      height: 480px;
      background-color: #fff;
      text-align: center;
      display: inline-block;
      vertical-align: top;
      margin-left: 26.5px;
      .toptitle{
        height: 125px;
        background-color: #E1BA84;
        .toptitle_p1{
          font-size: 32px;
          color: #ffffff;
          text-align: center;
          padding-top: 25px;
        }
        .toptitle_p2{
          font-size: 14px;
          color: #ffffff;
          text-align: center;
          margin-top: 10px;
        }
      }
      .hotShow_hot_img{
        text-align: center;
        height: 237px;
        padding-top: 30px;
        img{
          width: 181px;
          height: 237px;
        }
      }
      .hotShow_like_num{
        display: inline-block;
        margin-bottom: 8px;
        width: 220px;
        height: 35px;
        text-align: center;
        line-height: 35px;
        border: 1px solid #F2F2F2;
        font-size: 14px;
        color: #333333;
        margin-top: 12px;
      }
    }
    .hotShow_user{
      width: 280px;
      height: 480px;
      background-color: #fff;
      text-align: center;
      display: inline-block;
      vertical-align: top;
      margin-left: 26.5px;
      .toptitle{
        height: 125px;
        background-color: #33CC99;
        .toptitle_p1{
          font-size: 32px;
          color: #ffffff;
          text-align: center;
          padding-top: 25px;
        }
        .toptitle_p2{
          font-size: 14px;
          color: #ffffff;
          text-align: center;
          margin-top: 10px;
        }
      }
      .hotShow_user_img{
        height: 237px;
        text-align: center;
        padding-top: 30px;
        img{
          width: 118px;
          height: 118px;
          margin-top: 20px;
          border-radius: 50%;
        }
        .username{
          height: 60px;
          line-height: 60px;
          text-align: center;
          font-weight: 500;
          font-size: 18px;
          color: #333333;
        }
      }
      .hotShow_like_num{
        display: inline-block;
        margin-bottom: 8px;
        width: 220px;
        height: 35px;
        text-align: center;
        line-height: 35px;
        border: 1px solid #F2F2F2;
        font-size: 14px;
        color: #333333;
        margin-top: 12px;
      }
    }
    .hotShow_newmsg{
      width: 280px;
      height: 480px;
      background-color: #fff;
      text-align: center;
      display: inline-block;
      vertical-align: top;
      margin-left: 26.5px;
      .toptitle{
        height: 125px;
        background-color: #6FB9F7;
        .toptitle_p1{
          font-size: 32px;
          color: #ffffff;
          text-align: center;
          padding-top: 25px;
        }
        .toptitle_p2{
          font-size: 14px;
          color: #ffffff;
          text-align: center;
          margin-top: 10px;
        }
      }
    }
  }
    .newsBox{
      position: relative;
      width: 100%;
      background-color: #F9F9F9;
      .top{
        position: absolute;
        width: 100%;
        height: 680px;
        top: -180px;
        z-index: 7;
        background-color: #fff;
        .navs{
          height: 40px;
          background-color: #7e6b5a;
          width: 100%;
          .w1200s{
            width: 1200px;
            height: 40px;
            background-color: #7e6b5a;
            margin: 0 auto;
            position: relative;
            .head-ul{
              display: inline-block;
              overflow: hidden;
              height: 40px;
              background-color: #7e6b5a;
              li{
                display: inline-block;
                margin-top: 10px;
                a{
                  padding: 5px 14px;
                  margin: 0 5px;
                  cursor: pointer;
                  color: #ffffff;
                }
              }
            }
            .right_box{
              display: inline-block;
              float: right;
              .login_register{
                border-radius: 5px;
                float: right;
                width: 88px;
                height: 28px;
                margin: 5px 20px;
                line-height: 28px;
                /*border: 1px solid #ed4040;*/
                a{
                  display: inline-block;
                  width: 42px;
                  text-align: center;
                  height: 16px;
                  margin-top: 6px;
                  font-size: 12px;
                  line-height: 16px;
                  color: #ffffff;
                }
              }
              .login_register a:nth-of-type(1){
                border-right: 1px solid #fff;
              }
              .userBox {
                border-radius: 5px;
                width: 90px;
                height: 30px;
                margin: 5px 20px;
                line-height: 30px;
                transition: 0.5s;
                position:absolute;
                z-index: 5;
                right: 0;
                top: 0;
                overflow: hidden;
                &:hover{
                  height:240px;
                }
                .imgBox{
                  width: 30px;
                  height: 30px;
                  border-radius: 50%;
                  display: inline-block;
                  background-color:#e6e6e6;
                  vertical-align: top;
                  cursor: pointer;
                  font-size: 0;
                  img{
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                  }
                }
                .usercontent{
                  width: 150px;
                  display: inline-block;
                  height: 30px;
                  font-size: 12px;
                  color: #ffffff;
                  /*overflow: hidden;*/
                  margin-left: 5px;
                  cursor: pointer;
                  position: absolute;
                  z-index: 6;
                }
                .list{
                  margin-top: 10px;
                  background-color: #fff;
                  li{
                    text-align: center;
                    height: 36px;
                    line-height: 36px;
                    font-size: 12px;
                    cursor: pointer;
                    &:hover{
                      background-color: #ed4040;
                    }
                  }
                }
              }
            }
          }
        }
        .logoBox{
          width: 444px;
          height: 60px;
          font-size: 0;
          display: inline-block;
          cursor: pointer;
          margin-top: 40px;
          vertical-align: top;
          img{
            width: 444px;
            height: 60px;
          }
        }
        .searchbox{
          display: inline-block;
          overflow: hidden;
          float: right;
          margin-top: 45px;
          span{
            display: inline-block;
            height: 38px;
            width: 98px;
            border: 1px solid #7e6b5a;
            vertical-align: top;
            text-align: center;
            line-height: 40px;
          }
          .keys_input{
            height: 38px;
            width: 313px;
            border-top: 1px solid #7e6b5a;
            border-bottom: 1px solid #7e6b5a;
            border-left: 1px solid #7e6b5a;
            padding-left:5px;
            vertical-align: top;
          }
          .btn{
            display: inline-block;
            background-color: #7e6b5a;
            color: #ffffff;
            line-height: 40px;
            height: 40px;
            text-align: center;
            width: 101px;
            cursor: pointer;
          }
        }

      }
      .bannerbox{
        width: 100%;
        height: 500px;
        font-size: 0;
        background-position: center center;
        background-size: auto 100%;
        /*top: 2px;*/
        margin-top: -5px;
        /*z-index: 999;*/
        img{
          width: 100%;
          height: 500px;
        }
        .numberCount {
          position: absolute;
          top: 332px;
          width: 100%;
          text-align: center;
          color: #bb955b;
          font-family: '微软宋体';
        }
      }
      .content{
        padding-top: 40px;
        overflow: hidden;
        background-color: #F9F9F9;
        .topshow{
          overflow: hidden;
          margin-top: 40px;
          text-align: center;
          vertical-align: top;
          .lis{
            display: inline-block;
            width: 400px;
            height: 195px;
            padding-top: 45px;
            p{
              text-align: center;
              color: #ffffff;
              margin-bottom: 20px;
              font-size: 21px;
            }
            span{
              display: inline-block;
              width: 160px;
              height: 40px;
              background-color: #584b3f;
              line-height: 40px;
              color: #c3a14f;
              margin-top: 35px;
              cursor: pointer;
              &:hover{
                background-color: #c3a14f;
                color: #ffffff;
              }
            }
          }
        }
        .firstcolumn_tip{
          margin-top: 20px;
          height: 68px;
          /*border: 1px solid #f0f0f0;*/
          text-align: center;
          line-height: 68px;
          background-color: #fff;
          font-size: 24px;
          color: #353535;
          font-weight: 600;
          img{
            width: 272px;
            height: 29px;
            margin-top: 20px;
          }
        }
        .pushu_nav{
          overflow: hidden;
          text-align: center;
          background-color: #fff;
          padding: 20px 0;
          span{
            font-size: 15px;
            color: #333333;
          }
          .names{
            margin: 0 13px;
            cursor: pointer;
          }
          .activenames{
            margin: 0 13px;
            cursor: pointer;
            color: #7e6b5a;
          }
        }
        .showlist{
          width: 1200px;
          height: 320px;
          font-size: 0;
          background-color: #fff;
          img{
            width: 1200px;
            height: 320px;
          }
          .lilist{
            position: relative;
            /*margin-top: 43px;*/
            display: inline-block;
            width: 162px;
            overflow: hidden;
            margin-left: 108px;
            img{
              width: 162px;
              height: 211px;
              cursor: pointer;
            }
            p{
              color: #333333;
              margin-top: 5px;
              font-size: 14px;
            }
            .tip{
              position: absolute;
              top: 7px;
              left: 9px;
              display: inline-block;
              width: 60px;
              background-color:rgba(0,0,0,.3);
              color: #ffffff;
              height: 20px;
              line-height: 20px;
              font-size: 12px;
              text-align: center;
              border-radius: 2px;
              cursor: pointer;
              &:hover{
                color: #ed4040;
              }
            }
          }
        }
        .addMore{
          height: 38px;
          border: 1px solid #f0f0f0;
          text-align: center;
          line-height: 40px;
          font-size: 12px;
          cursor: pointer;
          background-color: #fff;
          margin-bottom: 30px;
          span{
            color: #666666;
            &:hover{
              color: #ed4040;
            }
          }
        }
      }
      .foot_banners{
        width: 100%;
        height: 400px;
        font-size: 0;
        position: relative;
        img{
          width: 100%;
          height: 400px;
        }
        p{
          position: absolute;
          font-size: 42px;
          font-family:  KaiTi,SimSun;
          text-align: center;
          width: 100%;
          color: #ffffff;
        }
        .p1{
          top: 80px;
        }
        .p2{
          top: 180px;

        }
        .p3{
          bottom: 54px;
          a{
            color: #ffffff;
            font-size: 17px;
            background-color:rgba(78,55,33,.6);
            display: inline-block;
            font-family: normal;
            width: 240px;
            height: 50px;
            line-height: 50px;
            cursor: pointer;
            &:hover{
              color: #ed4040;
            }
          }
        }
      }
    }
    .center{
      background-color: #fff;
      overflow: hidden;
      padding-bottom: 20px;
      .puxi_content{
        display: inline-block;
        margin-left: 20px;
        margin-top: 20px;
        width: 275px;
        height: 278px;
        transition: 0.3s;

        &:hover{
          transform: translate(0,-3px);
        }
        .libox{
          display: inline-block;
          width: 100%;
          font-size: 0;
          position: relative;
          .topColumnname{
            text-align: center;
            position: absolute;
            top:10px;
            left: 10px;
            padding: 0 5px;
            background-color:rgba(51,51,51,.5);
            font-size: 12px;
            color: #ffffff;
            height: 18px;
            line-height: 18px;
            border-radius: 3px;
            cursor: pointer;
            &:hover{
              background-color: rgba(237,64,64,.5);
            }
          }
          .imgbox{
            display: inline-block;
            width: 275px;
            height: 183px;
            font-size: 0;
            cursor: pointer;
            img{
              width: 100%;
              height: 100%;
            }
          }
          p{
            width: 263px;
            height: 93px;
            border-left: 1px solid #f0f0f0;
            border-right: 1px solid #f0f0f0;
            border-bottom: 1px solid #f0f0f0;
            -moz-box-shadow:1px 1px 3px #f3f3f3;
            -webkit-box-shadow:1px 1px 3px #f3f3f3;
            box-shadow:1px 1px 3px #f3f3f3;
            text-align: left;
            padding-left: 10px;
            .titlename{
              color: #333333;
              font-size: 14px;
              font-weight:500;
              display: inline-block;
              padding-top: 8px;
              height:55px;
              line-height: 25px;
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            .hot_time{
              display: inline-block;
              width: 155px;
              height: 20px;
              margin-top: 5px;
              font-size: 12px;
              color: #b2b2b2;
            }
            .viewNumber{
              display: inline-block;
              height: 20px;
              width: 50px;
              margin-top: 10px;
              font-size: 12px;
              color: #b2b2b2;
              svg{
                vertical-align:middle;
              }
            }
            .viewStar{
              width: 50px;
            }
          }
        }
      }
    }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px){
    .topshow,.dataBaseTopBox{
      display: none;
    }
    .newsBox{
      .foot_banners{
        height: 200px;
        img{
          height: 200px;
        }
        p{
          font-size: 24px;
        }
        .p1{
          top: 40px;
        }
        .p2{
          top:70px;
        }
        .p3{
          bottom: 20px;
        }
      }
      .top{
        top: 0;
        height: 188px;
        .bannerbox{
          margin-top: 0;
          height: 175px;
          .numberCount{
            top: 114px;
            .newCount{
              font-size: 23px;
            }
          }
        }
      }
      .content{
        padding-top: 165px;
      }
    }
  }
</style>

